import { FC } from "react";
import styled from "styled-components";
import ContractService from "../../../services/contract"
import HelperService from "../../../services/helper"
import { Contract } from '../../../models/contract';
import useNotyf from "../../../context/useNotify";
import { useUser } from "../../../context/useUser";
import { useLeague } from "../../../context/useLeague";

interface Props {
  contract: Contract;
  closeModal: () => void;
}

const AcceptContractModal: FC<Props> = ({ contract, closeModal }) => {

  const notfy = useNotyf()
  const { tokenLogin, user } = useUser()
  const { getLeagueById } = useLeague()

  // API
  const acceptContract = async () => {
    try {
      await ContractService.updateContract(contract._id, { isAccepted: true })
      notfy.success("✅🏃‍♂️⚽ Contract accepted!")
      await tokenLogin()
      if (user?.leagues[0]) {
        await getLeagueById(user?.leagues[0])
      }
    } catch (err) {
      console.log(err);
      HelperService.showNotfyErr(notfy, err, "Error accepting contract")
    } finally {
      closeModal()
    }
  }

  const rejectContract = async () => {
    try {
      await ContractService.deleteContract(contract._id)
      notfy.success("❌ Contract rejected.")
      tokenLogin()
    } catch (err) {
      console.log(err);
      HelperService.showNotfyErr(notfy, err, "Error rejecting contract")
    } finally {
      closeModal()
    }
  }

  // Methods
  const handleClickAccept = () => {
    acceptContract()
  };
  const handleClickReject = () => {
    rejectContract()
  };

  return (
    <Wrapper>
      <Container>
        <CloseButtonContainer>
          <h3 className="p-0 m-0">New Contract Offer</h3>
          <CloseButton onClick={closeModal} className="btn btn-sm btn-light">
            X
          </CloseButton>
        </CloseButtonContainer>
        <InfoContainer>
          <DivisionLogoContainer>
            {/* <DivisionImg src={contract.team.divisionLogo}></DivisionImg> */}
          </DivisionLogoContainer>
          <ClubInfoContainer>
            <InfoItem>
              {/* <Title>Manager:</Title> */}
              {/* <ManagerImage src={contract.team.managerImage}></ManagerImage> */}
              <Name>{contract.team.manager}</Name>
            </InfoItem>
            <InfoItem>
              <Name style={{ fontSize: "larger" }}>{contract.team.name}</Name>
            </InfoItem>
          </ClubInfoContainer>
        </InfoContainer>
        <BadgeContainer>
          <BadgeImg src={contract.team.image}></BadgeImg>
        </BadgeContainer>
        <GamesRemainingContainer>
          <GamesRemainingBox>
            <span
              style={{
                fontWeight: "800",
                fontSize: "larger",
              }}
            >
              {contract.seasonsRemaining}
            </span>
            seasons
          </GamesRemainingBox>
        </GamesRemainingContainer>
        <AcceptContainer>
          <Button
            style={{ backgroundColor: "green" }}
            onClick={() => handleClickAccept()}
            className={"btn btn-success"}
          >
            ACCEPT
          </Button>
          <Button
            style={{ backgroundColor: "red" }}
            onClick={() => handleClickReject()}
            className={"btn btn-danger"}
          >
            REJECT
          </Button>
        </AcceptContainer>
      </Container>
    </Wrapper>
  );
};
export default AcceptContractModal;
const Wrapper = styled.div`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  border: white solid 0.5px;
  border-radius: 8px;

  width: 97%;
  max-width: 420px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Container = styled.div`
  width: 100%;
  background-color: rgb(74, 74, 74);
  border: rgb(74, 74, 74) solid 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;
const CloseButtonContainer = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  background-color: rgb(127, 127, 127);
  border-radius: 8px;
`;
const CloseButton = styled.button`
  float: right;
`;
const InfoContainer = styled.div`
  width: 100%;
  background-color: rgb(74, 74, 74);
  display: flex;
  justify-content: center;
`;
const DivisionLogoContainer = styled.div`
  flex: 2 0 0;
  padding: 15px 15px 15px 0px;
  border-radius: 8px;
`;
const DivisionImg = styled.img`
  width: 100%;
  padding: 10px;
  background-color: rgb(127, 127, 127);
  border-radius: 8px;
`;
const ClubInfoContainer = styled.div`
  flex: 4 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 15px 0;
  gap: 15px;
`;
const InfoItem = styled.div`
  width: 100%;
  flex: 1 0 0;
  background-color: rgb(127, 127, 127);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;
const ManagerImage = styled.img`
  height: 40px;
  border-radius: 8px;
`;
const Name = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 700;
  letter-spacing: 0.04rem;
`;
const BadgeContainer = styled.div`
  width: 100%;
  height: 100%;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  background-color: rgb(127, 127, 127);
`;
const BadgeImg = styled.img`
  width: 180px;
  padding: 18px;
  background-color: rgb(127, 127, 127);
  border-radius: 8px;
`;
const GamesRemainingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(127, 127, 127);
`;
const GamesRemainingBox = styled.div`
  height: 70px;
  aspect-ratio: 1/1;
  background-color: rgb(38, 38, 38);
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: smaller;
`;
const AcceptContainer = styled.div`
  gap: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: rgb(127, 127, 127);
`;
const Button = styled.button`
  border: rgb(74, 74, 74) solid 1px;
  padding: 0.5rem 1rem;
  margin: 15px 0px;
  width: 40%;
  border-radius: 8px;
`;
